module.exports = {"require":"จำเป็นต้องระบุ"}


//////////////////
// WEBPACK FOOTER
// ./src/wording/pages/validate/TH.json
// module id = 1353
// module chunks = 121